import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Role } from '../util/enums/role.enum';

@Injectable({ providedIn: 'root' })
export class UserInfoService {
  protected USER_INFO_PATH = '/userInfo';
  protected COUNTRY_PATH = '/locales/country/unique'
  initialSubs: Subscription = new Subscription();
  roles: any[] = [];
  appTitle = '';
  userDetails: any;
  menuDetails = [];
  groups: any[] = [];
  countryList = [];
  email = '';

  constructor(private commonService: CommonService,
    readonly http: HttpClient,
    readonly router: Router
  ) { }

  getUserInfo(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // let headers = { headers: { 'Accept-Version': 'V2' } }
      this.commonService.getCall(environment.API_BASE_PATH + this.USER_INFO_PATH).subscribe({
        next: (response) => {
          this.getCountries();
          this.setupUser(response);
          this.initialSubs.unsubscribe();
          resolve(true);
        },
        error: () => {
          reject(true);
        }
      })
    })
  }

  getMenuList(tenantID: string, lang?: any): Observable<any> {
    let headers = { headers: { 'X-tenant-ID': String(tenantID), 'Accept-Language': lang ,'Accept-Version': 'V2'} }
    return this.commonService.getCall(environment.API_BASE_PATH + '/tenant/menu', headers);
    //  return this.http.get('assets/menu.json')
  }

  redirectPath(node: any) {
    this.router.navigate([node.path, { routeID: node.id }]);
  }

  setupUser(userDetails: any) {
    this.roles = userDetails['roles'];
    this.appTitle = userDetails['appTitle'];
    this.userDetails = userDetails;
    !!this.userDetails.prefCountry ? this.userDetails.prefCountry : 'IN'
    let groupList = userDetails['groups'] ? userDetails['groups'].map(res => res.toLowerCase()) : [];
    this.groups = groupList;
    this.email = userDetails['email']
  }

  get menuList(): any {
    return this.menuDetails;
  }

  set menuList(value: any) {
    this.menuDetails = value;
  }

  filterPermission(id: number, permission: string): boolean {
    let menuArray = !!localStorage.menuList ? JSON.parse(localStorage.menuList) : [];
    const idExists = menuArray.some(res => res.id === id)
    if (!!idExists && !!permission) {
      let details: any = JSON.parse(localStorage.menuList).find(res => res.id == id);
      return !!details.actions && details.actions.includes(permission) ? true : false;
    } else {
      return false;
    }
  }

  filterTabPermission(id: number, type: string) {
    let menuArray = !!localStorage.menuList ? JSON.parse(localStorage.menuList) : [];
    let resultmenu = menuArray.filter(res => res.parent_id == id && res.type == type);
    return resultmenu;
  }

  filterAllTabsPermission(id: number) {
    let menuArray = !!localStorage.menuList ? JSON.parse(localStorage.menuList) : [];
    let selectedValue = !!menuArray ? menuArray.find(res => res.id == id) : {};
    let filterLinks = !!selectedValue ? (selectedValue.links ? selectedValue.links : []) : []
    let resultmenu = menuArray.filter(res => filterLinks.includes(res.id));
    return resultmenu;
  }

  getPermittedTabs(id: number, tabDetails: any) {
    let tabs = this.filterAllTabsPermission(id);
    tabDetails = tabDetails.map(itemA => {
      const match = tabs.find(itemB => itemB.id === itemA.id);
      return match ? { ...itemA, enable: true, name: match.name } : itemA;
    })
    return tabDetails;
  }

  isTabExists(id: number): boolean {
    let getTabsPermission = this.filterAllTabsPermission(id);
    return !!getTabsPermission && getTabsPermission.length > 0;
  }

  // Check whether is SUPERADMIN || ADMIN
  isAdminGroup() {
    return this.groups.includes(Role.SUPERADMIN) || this.groups.includes(Role.ADMIN);
  }

  isCPOSubCPOGroup() {
    return this.groups.includes(Role.CPO) || this.groups.includes(Role.SUBCPO)
  }

  isStationManagerCPOGroup() {
    return this.groups.includes(Role.STATIONMANAGER)
  }

  getCountries() {
    let headers = { headers: {  'Accept-Version': 'V2' } }
    this.commonService.getCall(environment.API_BASE_PATH + this.COUNTRY_PATH , headers).subscribe((res: any) => {
      if (!!res) {
        this.countryList = res;
        return !!this.countryList ? this.countryList : []
      }
    }, err => {
      this.countryList = [];
    });
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
